import apiRequest from '@/utils/apiRequest';
import { RequestUserData } from '@/utils/apiRequest/types';

import { ProgramResponse } from './getProgram';

export async function getGuide(
	guideId: string | string[] | undefined,
	userData: RequestUserData,
): Promise<ProgramResponse | null> {
	const id = Array.isArray(guideId) ? guideId[0] : guideId;
	try {
		if (!id) return null;
		const result = await apiRequest<ProgramResponse>({
			endpoint: `content/programs/guides/${id}`,
			method: 'GET',
			customHeaders: {
				'x-device-capabilities': 'v1;signedCookie;streamOnly',
			},
			userData,
		});

		return result?.data;
	} catch (err) {
		return null;
	}
}
